export default __webpack_public_path__ + "static/media/replace-parts.6874c6d2.jpg";